import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TProfileCalendarApiResponse } from '../../../../apis/profile/profile.interfaces';
import { useProfileService } from '../../../../apis/profile/useProfileService';

type TQueryError = IFHError<{ message: string }>;
export const getProfileCalendarListKey = 'get-profile-calendar-list';

export const useProfileCalendarListHook = (
  options?: Omit<
    UseQueryOptions<TProfileCalendarApiResponse, TQueryError>,
    'queryKey' | 'queryFn'
  >
): UseQueryResult<TProfileCalendarApiResponse, TQueryError> => {
  const { getProfileCalendarList } = useProfileService();

  return useQuery<TProfileCalendarApiResponse, TQueryError>({
    queryKey: [getProfileCalendarListKey],
    queryFn: () => getProfileCalendarList(),
    enabled: true,
    ...options,
  });
};
